import React, { useEffect, useState } from "react";
import {
  customTimeFormater,
  dateAndTimeFormatter,
  getCurrentWorkspaceId,
  reversesDateFormatter,
  startApiCall,
} from "../../../../../global-functions/globalFunctions";
import CustomTooltip from "../../../../../components/CustomTooltip/CustomTooltip";
import { activityGroupRelatedEndpoints } from "../../../../../api/Endpoints";
import ApiCall from "../../../../../api/ApiCall";
import { Avatar } from "../../../../../components/Avatar/Avatar";

function ActivityOverview({
  selectedEmployees,
  setassigneeModal,
  setactivityData,
  activityData,
  setStatusId,
  statusGroup,
  statusId,
  allActivity,
  setactivityGroup,
  setstatusGroup,
  activityDetails,
  setselectedEmployees,
  setselectedEmpId,
  handleGetMandatoryTask,
}) {
  const [loader3, setloader3] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [allStatus, setallStatus] = useState([]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setactivityData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleGetAllStatus = async (id) => {
    startApiCall(null, setloader3);
    const data = {
      page: 1,
      limit: 200,
      filters: {
        businessId: getCurrentWorkspaceId(),
        activityGroupId: id,
      },
    };
    const res = await ApiCall(
      "post",
      activityGroupRelatedEndpoints.getActivitySubStatus,
      data
    );
    if (res?.success) {
      setallStatus(res?.status?.data);
      setloader3(false);
    } else {
      setloader3(false);
    }
  };

  const handleGetAllGroup = async () => {
    startApiCall(null, setloader3);
    const data = {
      page: 1,
      limit: 5000,
      filters: {
        businessId: getCurrentWorkspaceId(),
      },
    };
    const res = await ApiCall(
      "post",
      activityGroupRelatedEndpoints.getActivityGroup,
      data
    );
    if (res?.success) {
      setAllGroups(res?.group?.data);
      setloader3(false);
    } else {
      setloader3(false);
    }
  };

  useEffect(() => {
    if (allActivity) {
      setStatusId(allActivity?.activityStatus);
      if (allActivity?.assignees && allActivity?.assignees.length > 0) {
        const empIds = allActivity?.assignees.map((assignee) => assignee._id);
        setselectedEmpId(empIds);
        setselectedEmployees(allActivity?.assignees);
      }
      setactivityData({
        taskTitle: allActivity?.title || "",
        activityDate: allActivity?.activityDate
          ? reversesDateFormatter(allActivity?.activityDate)
          : reversesDateFormatter(allActivity?.activityDate),
        activityTime: allActivity?.startTime
          ? customTimeFormater(allActivity?.startTime)
          : "",
        priority: allActivity?.priority,
        endTime: allActivity?.endTime
          ? customTimeFormater(allActivity?.endTime)
          : "",
        recordingLink: allActivity?.recordingLink,
        duration: allActivity?.duration,
        notes: allActivity?.notes,
      });
      setstatusGroup(allActivity?.activityGroup);
      setactivityGroup(allActivity?.activityGroupStatus);
    }
  }, [allActivity, activityDetails]);

  return (
    <div className="mh-500p overflow-auto">
      {allActivity?.taskType === "task" && (
        <>
          <div className="row gx-3 px-3 w-100 mt-4">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Title</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-90 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="text"
                    name="taskTitle"
                    required
                    value={activityData.taskTitle}
                    onChange={handleChange}
                    placeholder="Task Title"
                  />
                </div>
                <span className="d-flex align-items-center justify-content-center w-10 py-1 px-2 fs-7">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.413 10.5907C18.173 10.5907 17.9767 10.787 17.9767 11.027V21.0459C17.9767 21.5914 17.5316 22.0321 16.9861 22.0321H2.95266C2.4072 22.0321 1.96648 21.587 1.96648 21.0459V7.01247C1.96648 6.46702 2.41157 6.02629 2.95266 6.02629H12.9672C13.2072 6.02629 13.4036 5.82993 13.4036 5.58993C13.4036 5.34993 13.2072 5.15356 12.9672 5.15356H2.95266C1.9272 5.15356 1.09375 5.98702 1.09375 7.01247V21.0503C1.09375 22.0757 1.9272 22.9092 2.95266 22.9092H16.9905C18.0159 22.9092 18.8538 22.0757 18.8538 21.0503V11.027C18.8494 10.787 18.653 10.5907 18.413 10.5907Z"
                      fill="#979797"
                    />
                    <path
                      d="M22.5333 2.62684L21.3726 1.46611C20.8751 0.968654 20.0635 0.968654 19.5617 1.46611L12.4053 8.62247C12.3573 8.67047 12.3181 8.73156 12.3006 8.79702L11.1704 12.2792C11.1181 12.4363 11.1617 12.6065 11.2751 12.7243C11.3581 12.8072 11.4715 12.8508 11.585 12.8508C11.6286 12.8508 11.6766 12.8421 11.7202 12.829L15.2024 11.6988C15.2679 11.677 15.329 11.6421 15.377 11.5941L22.5333 4.43774C23.0351 3.93593 23.0351 3.12429 22.5333 2.62684ZM15.0715 10.6647L13.3348 8.92793L18.5362 3.72647L20.273 5.4632L15.0715 10.6647ZM12.9115 9.73956L14.2555 11.0836L12.2657 11.7294L12.9115 9.73956ZM21.9181 3.81811L20.8926 4.84356L19.1559 3.10684L20.1813 2.08138C20.3384 1.92429 20.6002 1.92429 20.7573 2.08138L21.9181 3.24211C22.0751 3.3992 22.0751 3.65665 21.9181 3.81811Z"
                      fill="#979797"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Assigned Participants</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-80 py-1 px-1">
                  {selectedEmployees?.length > 0 && (
                    <div className="avatar-group avatar-group-sm avatar-group-overlapped me-6 pointer">
                      {selectedEmployees?.slice(0, 4)?.map((emp) => {
                        return (
                          <CustomTooltip text={emp?.name} placement="bottom">
                            <Avatar
                              name={emp?.name}
                              count={1}
                              image={emp?.image}
                              size="sm"
                              color="primary"
                            />
                          </CustomTooltip>
                        );
                      })}
                      {selectedEmployees?.length > 4 && (
                        <div className="avatar avatar-xs avatar-soft-indigo avatar-rounded">
                          <span className="initial-wrap">
                            +{selectedEmployees.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {selectedEmployees?.length === 0 && (
                    <span className="px-2 py-1">No Selected Employees </span>
                  )}
                </div>
                <span className="d-flex align-items-center justify-content-center w-20 py-1 px-2 fs-7">
                  <CustomTooltip text="add assignee" placement="bottom">
                    <span
                      className="btn btn-icon circle btn-sm btn-soft-primary"
                      onClick={() => {
                        setassigneeModal(true);
                      }}
                    >
                      <span className="feather-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-add"
                          viewBox="0 0 16 16"
                        >
                          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                          <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                        </svg>
                      </span>
                    </span>
                  </CustomTooltip>
                </span>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Due Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-100 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="date"
                    name="activityDate"
                    required
                    value={activityData.activityDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Current Status</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className={`d-flex align-items-center justify-content-between w-100  py-2 px-2  dropdown-toggle text-capitalize`}
                      aria-expanded="false"
                      type="button"
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        handleGetAllStatus(statusGroup?._id);
                      }}
                    >
                      {statusId?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : allStatus?.length > 0 ? (
                        <>
                          {allStatus?.map((status, index) => {
                            return (
                              <>
                                <button
                                  className="dropdown-item text-capitalize  d-flex align-items-center border-bottom rounded-0"
                                  type="button"
                                  onClick={() => {
                                    handleGetMandatoryTask(
                                      allActivity?._id,
                                      status?._id,
                                      allActivity,
                                      status?.name
                                    );
                                  }}
                                  disabled={status?._id === statusId?._id}
                                >
                                  {index + 1}. {status?.name} (
                                  {status?.activityGroupStatus?.name})
                                </button>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <span> No Status Found</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Choose Priority</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 ">
                    <select
                      className="form-select form-select-md p-2"
                      value={activityData?.priority}
                      required
                      name="priority"
                      onChange={handleChange}
                    >
                      <option disabled>Priority</option>
                      <option value="high">High</option>
                      <option value="low">Low</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label">Activity Group</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className="d-flex align-items-center justify-content-between w-100  py-2 px-2 text-secondary"
                      aria-expanded="false"
                      type="button"
                      disabled
                      data-bs-toggle="dropdown"
                      // onClick={() => {
                      //   handleGetAllGroup();
                      // }}
                    >
                      {statusGroup?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : (
                        <>
                          {allGroups?.map((item, index) => (
                            <span
                              disabled={
                                allActivity?.activityGroup?._id === item?._id
                              }
                              className="dropdown-item text-capitalize d-flex align-items-center gap-1 border-bottom rounded-0"
                              key={item._id}
                              value={item._id}
                              onClick={() => {
                                setstatusGroup(item);
                              }}
                            >
                              {index + 1}. {item?.name}
                            </span>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified</label>

              <div className="d-flex align-items-center border rounded-3 w-100 ">
                <div className="d-flex align-items-center border rounded-3 w-100 ">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {dateAndTimeFormatter(allActivity?.updatedAt)}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Deadline Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 ">
                <div className="d-flex align-items-center border rounded-3 w-100 ">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {allActivity?.dealLineDate
                      ? dateAndTimeFormatter(allActivity?.dealLineDate)
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Created By</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.createdBy?.name}
                      count={1}
                      image={allActivity?.createdBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.createdBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified by</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.actionBy?.name}
                      count={1}
                      image={allActivity?.actionBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.actionBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6">
              <div className="form-group">
                <div className="form-group">
                  <label className="form-label">Note</label>
                  <div className="todo-toolbar">
                    <textarea
                      className="form-control"
                      rows="3"
                      name="notes"
                      value={activityData.notes}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {allActivity?.taskType === "call" && (
        <>
          <div className="row gx-3 px-3 w-100 mt-2">
            <div className="col-sm-6 mt-3">
              {allActivity?.isLog === true ? (
                <span>
                  Log call{" "}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.2943 11.9999C27.558 11.9999 27.8158 11.9217 28.035 11.7752C28.2543 11.6287 28.4252 11.4205 28.5261 11.1768C28.627 10.9332 28.6534 10.6651 28.602 10.4065C28.5505 10.1478 28.4235 9.91023 28.2371 9.72376C28.0506 9.53729 27.813 9.4103 27.5544 9.35886C27.2957 9.30741 27.0277 9.33382 26.784 9.43473C26.5404 9.53565 26.3321 9.70655 26.1856 9.92581C26.0391 10.1451 25.9609 10.4029 25.9609 10.6666C25.9609 11.0202 26.1014 11.3593 26.3515 11.6094C26.6015 11.8594 26.9406 11.9999 27.2943 11.9999ZM23.2943 11.9999C23.558 11.9999 23.8158 11.9217 24.035 11.7752C24.2543 11.6287 24.4252 11.4205 24.5261 11.1768C24.627 10.9332 24.6534 10.6651 24.602 10.4065C24.5505 10.1478 24.4235 9.91023 24.2371 9.72376C24.0506 9.53729 23.813 9.4103 23.5544 9.35886C23.2957 9.30741 23.0277 9.33382 22.784 9.43473C22.5404 9.53565 22.3321 9.70655 22.1856 9.92581C22.0391 10.1451 21.9609 10.4029 21.9609 10.6666C21.9609 11.0202 22.1014 11.3593 22.3515 11.6094C22.6015 11.8594 22.9406 11.9999 23.2943 11.9999ZM19.2943 11.9999C19.558 11.9999 19.8158 11.9217 20.035 11.7752C20.2543 11.6287 20.4252 11.4205 20.5261 11.1768C20.627 10.9332 20.6534 10.6651 20.602 10.4065C20.5505 10.1478 20.4235 9.91023 20.2371 9.72376C20.0506 9.53729 19.813 9.4103 19.5544 9.35886C19.2957 9.30741 19.0277 9.33382 18.784 9.43473C18.5404 9.53565 18.3321 9.70655 18.1856 9.92581C18.0391 10.1451 17.9609 10.4029 17.9609 10.6666C17.9609 10.8417 17.9954 11.015 18.0624 11.1768C18.1294 11.3386 18.2276 11.4856 18.3515 11.6094C18.4753 11.7332 18.6222 11.8314 18.784 11.8984C18.9458 11.9654 19.1192 11.9999 19.2943 11.9999ZM25.2143 17.3332C24.9209 17.3332 24.6143 17.2399 24.3209 17.1732C23.7269 17.0423 23.1432 16.8685 22.5743 16.6532C21.9557 16.4282 21.2758 16.4399 20.6653 16.686C20.0549 16.9322 19.557 17.3954 19.2676 17.9866L18.9743 18.5866C17.6736 17.861 16.4762 16.9641 15.4143 15.9199C14.3752 14.8585 13.4787 13.6662 12.7476 12.3732L13.3343 11.9999C13.9254 11.7105 14.3886 11.2126 14.6348 10.6022C14.8809 9.99171 14.8926 9.31179 14.6676 8.69324C14.4559 8.12313 14.2822 7.53964 14.1476 6.94657C14.0809 6.63991 14.0276 6.34657 13.9876 6.03991C13.8257 5.10073 13.3338 4.25023 12.6004 3.64156C11.8671 3.03289 10.9405 2.70605 9.98759 2.71991H5.98759C5.42392 2.71917 4.86646 2.83757 4.35175 3.06735C3.83704 3.29713 3.37671 3.6331 3.00093 4.05324C2.61918 4.48323 2.33463 4.99048 2.16666 5.5404C1.99869 6.09032 1.95126 6.66999 2.02759 7.2399C2.72988 12.8226 5.27077 18.0127 9.24946 21.9914C13.2282 25.9701 18.4182 28.511 24.0009 29.2132C24.174 29.2265 24.3478 29.2265 24.5209 29.2132C25.5818 29.2132 26.5992 28.7918 27.3494 28.0417C28.0995 27.2915 28.5209 26.2741 28.5209 25.2132V21.2132C28.5071 20.2829 28.1693 19.3864 27.5658 18.6782C26.9622 17.97 26.1307 17.4944 25.2143 17.3332ZM25.8676 25.3332C25.8698 25.5265 25.8299 25.7179 25.7508 25.8943C25.6716 26.0706 25.5551 26.2276 25.4093 26.3545C25.2634 26.4813 25.0917 26.5749 24.9061 26.6288C24.7205 26.6827 24.5254 26.6956 24.3343 26.6666C19.3558 26.0169 14.7304 23.7441 11.1743 20.1999C7.62093 16.6197 5.35192 11.9645 4.72093 6.95991C4.69196 6.76435 4.70684 6.5648 4.76449 6.37571C4.82215 6.18661 4.92112 6.0127 5.05426 5.86657C5.17772 5.72602 5.32937 5.61302 5.49936 5.53492C5.66935 5.45681 5.85387 5.41536 6.04093 5.41324H10.0409C10.351 5.40634 10.6538 5.50774 10.8971 5.7C11.1405 5.89225 11.3092 6.16333 11.3743 6.46657C11.4276 6.83102 11.4943 7.19102 11.5743 7.54657C11.7283 8.24943 11.9333 8.94014 12.1876 9.61324L10.3209 10.4799C10.1613 10.5531 10.0178 10.6572 9.89847 10.786C9.77919 10.9149 9.68653 11.0661 9.62582 11.2308C9.56512 11.3956 9.53756 11.5707 9.54473 11.7462C9.55189 11.9217 9.59365 12.094 9.66759 12.2532C11.5865 16.3636 14.8906 19.6676 19.0009 21.5866C19.3255 21.7199 19.6896 21.7199 20.0143 21.5866C20.3451 21.4634 20.6136 21.2141 20.7609 20.8932L21.6009 19.0266C22.2902 19.2731 22.9937 19.4779 23.7076 19.6399C24.0543 19.7199 24.4276 19.7866 24.7876 19.8399C25.0884 19.9076 25.3564 20.0775 25.546 20.3206C25.7356 20.5637 25.8351 20.865 25.8276 21.1732L25.8676 25.3332Z"
                      fill="#979797"
                    />
                  </svg>
                </span>
              ) : (
                <span>
                  Schedule call{" "}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_7503_17957)">
                      <path
                        d="M10.875 18.75H8.625C8.52554 18.75 8.43016 18.7895 8.35983 18.8598C8.28951 18.9302 8.25 19.0255 8.25 19.125V21.375C8.25 21.4745 8.28951 21.5698 8.35983 21.6402C8.43016 21.7105 8.52554 21.75 8.625 21.75H10.875C10.9745 21.75 11.0698 21.7105 11.1402 21.6402C11.2105 21.5698 11.25 21.4745 11.25 21.375V19.125C11.25 19.0255 11.2105 18.9302 11.1402 18.8598C11.0698 18.7895 10.9745 18.75 10.875 18.75ZM10.5 21H9V19.5H10.5V21ZM18 21.4897C18.0294 21.5484 18.0737 21.5984 18.1285 21.6345C18.1832 21.6707 18.2465 21.6919 18.312 21.696H18.3353C18.397 21.696 18.4578 21.6807 18.5122 21.6515C18.5667 21.6223 18.613 21.5802 18.6473 21.5287L20.1473 19.2787C20.1746 19.2378 20.1936 19.1918 20.2031 19.1435C20.2127 19.0952 20.2127 19.0455 20.203 18.9972C20.1934 18.9489 20.1743 18.903 20.1469 18.862C20.1195 18.8211 20.0843 18.786 20.0434 18.7586C20.0024 18.7313 19.9564 18.7123 19.9081 18.7027C19.8598 18.6932 19.8101 18.6932 19.7618 18.7028C19.7135 18.7125 19.6676 18.7316 19.6266 18.7589C19.5857 18.7863 19.5506 18.8215 19.5233 18.8625L18.3818 20.5748L17.925 19.6545C17.8805 19.5655 17.8025 19.4978 17.7082 19.4663C17.6138 19.4348 17.5108 19.442 17.4218 19.4865C17.3327 19.531 17.265 19.609 17.2335 19.7033C17.202 19.7977 17.2093 19.9007 17.2537 19.9897L18 21.4897ZM17.625 17.25H19.875C19.9745 17.25 20.0698 17.2105 20.1402 17.1402C20.2105 17.0698 20.25 16.9745 20.25 16.875V14.625C20.25 14.5255 20.2105 14.4302 20.1402 14.3598C20.0698 14.2895 19.9745 14.25 19.875 14.25H17.625C17.5255 14.25 17.4302 14.2895 17.3598 14.3598C17.2895 14.4302 17.25 14.5255 17.25 14.625V16.875C17.25 16.9745 17.2895 17.0698 17.3598 17.1402C17.4302 17.2105 17.5255 17.25 17.625 17.25ZM18 15H19.5V16.5H18V15ZM17.625 12.75H19.875C19.9745 12.75 20.0698 12.7105 20.1402 12.6402C20.2105 12.5698 20.25 12.4745 20.25 12.375V10.125C20.25 10.0255 20.2105 9.93016 20.1402 9.85983C20.0698 9.78951 19.9745 9.75 19.875 9.75H17.625C17.5255 9.75 17.4302 9.78951 17.3598 9.85983C17.2895 9.93016 17.25 10.0255 17.25 10.125V12.375C17.25 12.4745 17.2895 12.5698 17.3598 12.6402C17.4302 12.7105 17.5255 12.75 17.625 12.75ZM18 10.5H19.5V12H18V10.5ZM4.125 17.25H6.375C6.47446 17.25 6.56984 17.2105 6.64017 17.1402C6.71049 17.0698 6.75 16.9745 6.75 16.875V14.625C6.75 14.5255 6.71049 14.4302 6.64017 14.3598C6.56984 14.2895 6.47446 14.25 6.375 14.25H4.125C4.02554 14.25 3.93016 14.2895 3.85984 14.3598C3.78951 14.4302 3.75 14.5255 3.75 14.625V16.875C3.75 16.9745 3.78951 17.0698 3.85984 17.1402C3.93016 17.2105 4.02554 17.25 4.125 17.25ZM4.5 15H6V16.5H4.5V15ZM4.125 21.75H6.375C6.47446 21.75 6.56984 21.7105 6.64017 21.6402C6.71049 21.5698 6.75 21.4745 6.75 21.375V19.125C6.75 19.0255 6.71049 18.9302 6.64017 18.8598C6.56984 18.7895 6.47446 18.75 6.375 18.75H4.125C4.02554 18.75 3.93016 18.7895 3.85984 18.8598C3.78951 18.9302 3.75 19.0255 3.75 19.125V21.375C3.75 21.4745 3.78951 21.5698 3.85984 21.6402C3.93016 21.7105 4.02554 21.75 4.125 21.75ZM4.5 19.5H6V21H4.5V19.5ZM4.125 12.75H6.375C6.47446 12.75 6.56984 12.7105 6.64017 12.6402C6.71049 12.5698 6.75 12.4745 6.75 12.375V10.125C6.75 10.0255 6.71049 9.93016 6.64017 9.85983C6.56984 9.78951 6.47446 9.75 6.375 9.75H4.125C4.02554 9.75 3.93016 9.78951 3.85984 9.85983C3.78951 9.93016 3.75 10.0255 3.75 10.125V12.375C3.75 12.4745 3.78951 12.5698 3.85984 12.6402C3.93016 12.7105 4.02554 12.75 4.125 12.75ZM4.5 10.5H6V12H4.5V10.5ZM20.625 3H20.25V1.5C20.25 1.10218 20.092 0.720644 19.8107 0.43934C19.5294 0.158035 19.1478 0 18.75 0C18.3522 0 17.9706 0.158035 17.6893 0.43934C17.408 0.720644 17.25 1.10218 17.25 1.5V3H6.75V1.5C6.75 1.10218 6.59196 0.720644 6.31066 0.43934C6.02936 0.158035 5.64782 0 5.25 0C4.85218 0 4.47064 0.158035 4.18934 0.43934C3.90804 0.720644 3.75 1.10218 3.75 1.5V3H3.375C2.87772 3 2.40081 3.19754 2.04917 3.54917C1.69754 3.90081 1.5 4.37772 1.5 4.875V22.125C1.5 22.6223 1.69754 23.0992 2.04917 23.4508C2.40081 23.8025 2.87772 24 3.375 24H20.625C21.1223 24 21.5992 23.8025 21.9508 23.4508C22.3025 23.0992 22.5 22.6223 22.5 22.125V4.875C22.5 4.37772 22.3025 3.90081 21.9508 3.54917C21.5992 3.19754 21.1223 3 20.625 3ZM18 1.5C18 1.30109 18.079 1.11032 18.2197 0.96967C18.3603 0.829018 18.5511 0.75 18.75 0.75C18.9489 0.75 19.1397 0.829018 19.2803 0.96967C19.421 1.11032 19.5 1.30109 19.5 1.5V4.5C19.5 4.69891 19.421 4.88968 19.2803 5.03033C19.1397 5.17098 18.9489 5.25 18.75 5.25C18.5511 5.25 18.3603 5.17098 18.2197 5.03033C18.079 4.88968 18 4.69891 18 4.5V1.5ZM4.5 1.5C4.5 1.30109 4.57902 1.11032 4.71967 0.96967C4.86032 0.829018 5.05109 0.75 5.25 0.75C5.44891 0.75 5.63968 0.829018 5.78033 0.96967C5.92098 1.11032 6 1.30109 6 1.5V4.5C6 4.69891 5.92098 4.88968 5.78033 5.03033C5.63968 5.17098 5.44891 5.25 5.25 5.25C5.05109 5.25 4.86032 5.17098 4.71967 5.03033C4.57902 4.88968 4.5 4.69891 4.5 4.5V1.5ZM21.75 22.125C21.75 22.4234 21.6315 22.7095 21.4205 22.9205C21.2095 23.1315 20.9234 23.25 20.625 23.25H3.375C3.07663 23.25 2.79048 23.1315 2.5795 22.9205C2.36853 22.7095 2.25 22.4234 2.25 22.125V8.25H21.75V22.125ZM21.75 7.5H2.25V4.875C2.25 4.57663 2.36853 4.29048 2.5795 4.0795C2.79048 3.86853 3.07663 3.75 3.375 3.75H3.75V4.5C3.75 4.89782 3.90804 5.27936 4.18934 5.56066C4.47064 5.84196 4.85218 6 5.25 6C5.64782 6 6.02936 5.84196 6.31066 5.56066C6.59196 5.27936 6.75 4.89782 6.75 4.5V3.75H17.25V4.5C17.25 4.89782 17.408 5.27936 17.6893 5.56066C17.9706 5.84196 18.3522 6 18.75 6C19.1478 6 19.5294 5.84196 19.8107 5.56066C20.092 5.27936 20.25 4.89782 20.25 4.5V3.75H20.625C20.9234 3.75 21.2095 3.86853 21.4205 4.0795C21.6315 4.29048 21.75 4.57663 21.75 4.875V7.5ZM9 12.4897C9.02941 12.5484 9.0737 12.5984 9.12845 12.6345C9.1832 12.6707 9.24649 12.6919 9.312 12.696H9.33525C9.39701 12.696 9.4578 12.6807 9.51223 12.6515C9.56666 12.6223 9.61304 12.5802 9.64725 12.5287L11.1473 10.2787C11.1746 10.2378 11.1936 10.1918 11.2031 10.1435C11.2127 10.0952 11.2127 10.0455 11.203 9.99717C11.1934 9.94888 11.1743 9.90295 11.1469 9.86202C11.1195 9.82109 11.0843 9.78596 11.0434 9.75863C11.0024 9.73129 10.9564 9.7123 10.9081 9.70273C10.8598 9.69316 10.8101 9.6932 10.7618 9.70284C10.7135 9.71249 10.6676 9.73155 10.6266 9.75895C10.5857 9.78634 10.5506 9.82153 10.5233 9.8625L9.38175 11.5747L8.925 10.6545C8.90299 10.6104 8.87251 10.5711 8.8353 10.5388C8.7981 10.5065 8.7549 10.4819 8.70817 10.4663C8.66144 10.4507 8.61209 10.4444 8.56295 10.4479C8.5138 10.4514 8.46583 10.4645 8.42175 10.4865C8.37768 10.5085 8.33837 10.539 8.30607 10.5762C8.27378 10.6134 8.24912 10.6566 8.23352 10.7033C8.21792 10.7501 8.21168 10.7994 8.21515 10.8486C8.21862 10.8977 8.23174 10.9457 8.25375 10.9897L9 12.4897ZM13.125 12.75H15.375C15.4745 12.75 15.5698 12.7105 15.6402 12.6402C15.7105 12.5698 15.75 12.4745 15.75 12.375V10.125C15.75 10.0255 15.7105 9.93016 15.6402 9.85983C15.5698 9.78951 15.4745 9.75 15.375 9.75H13.125C13.0255 9.75 12.9302 9.78951 12.8598 9.85983C12.7895 9.93016 12.75 10.0255 12.75 10.125V12.375C12.75 12.4745 12.7895 12.5698 12.8598 12.6402C12.9302 12.7105 13.0255 12.75 13.125 12.75ZM13.5 10.5H15V12H13.5V10.5ZM13.125 21.75H15.375C15.4745 21.75 15.5698 21.7105 15.6402 21.6402C15.7105 21.5698 15.75 21.4745 15.75 21.375V19.125C15.75 19.0255 15.7105 18.9302 15.6402 18.8598C15.5698 18.7895 15.4745 18.75 15.375 18.75H13.125C13.0255 18.75 12.9302 18.7895 12.8598 18.8598C12.7895 18.9302 12.75 19.0255 12.75 19.125V21.375C12.75 21.4745 12.7895 21.5698 12.8598 21.6402C12.9302 21.7105 13.0255 21.75 13.125 21.75ZM13.5 19.5H15V21H13.5V19.5ZM13.125 17.25H15.375C15.4745 17.25 15.5698 17.2105 15.6402 17.1402C15.7105 17.0698 15.75 16.9745 15.75 16.875V14.625C15.75 14.5255 15.7105 14.4302 15.6402 14.3598C15.5698 14.2895 15.4745 14.25 15.375 14.25H13.125C13.0255 14.25 12.9302 14.2895 12.8598 14.3598C12.7895 14.4302 12.75 14.5255 12.75 14.625V16.875C12.75 16.9745 12.7895 17.0698 12.8598 17.1402C12.9302 17.2105 13.0255 17.25 13.125 17.25ZM13.5 15H15V16.5H13.5V15ZM10.875 14.25H8.625C8.52554 14.25 8.43016 14.2895 8.35983 14.3598C8.28951 14.4302 8.25 14.5255 8.25 14.625V16.875C8.25 16.9745 8.28951 17.0698 8.35983 17.1402C8.43016 17.2105 8.52554 17.25 8.625 17.25H10.875C10.9745 17.25 11.0698 17.2105 11.1402 17.1402C11.2105 17.0698 11.25 16.9745 11.25 16.875V14.625C11.25 14.5255 11.2105 14.4302 11.1402 14.3598C11.0698 14.2895 10.9745 14.25 10.875 14.25ZM10.5 16.5H9V15H10.5V16.5Z"
                        fill="#979797"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_7503_17957">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              )}
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-2">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Title</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-90 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="text"
                    name="taskTitle"
                    required
                    value={activityData.taskTitle}
                    onChange={handleChange}
                    placeholder="Task Title"
                  />
                </div>
                <span className="d-flex align-items-center justify-content-center w-10 py-1 px-2 fs-7">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.413 10.5907C18.173 10.5907 17.9767 10.787 17.9767 11.027V21.0459C17.9767 21.5914 17.5316 22.0321 16.9861 22.0321H2.95266C2.4072 22.0321 1.96648 21.587 1.96648 21.0459V7.01247C1.96648 6.46702 2.41157 6.02629 2.95266 6.02629H12.9672C13.2072 6.02629 13.4036 5.82993 13.4036 5.58993C13.4036 5.34993 13.2072 5.15356 12.9672 5.15356H2.95266C1.9272 5.15356 1.09375 5.98702 1.09375 7.01247V21.0503C1.09375 22.0757 1.9272 22.9092 2.95266 22.9092H16.9905C18.0159 22.9092 18.8538 22.0757 18.8538 21.0503V11.027C18.8494 10.787 18.653 10.5907 18.413 10.5907Z"
                      fill="#979797"
                    />
                    <path
                      d="M22.5333 2.62684L21.3726 1.46611C20.8751 0.968654 20.0635 0.968654 19.5617 1.46611L12.4053 8.62247C12.3573 8.67047 12.3181 8.73156 12.3006 8.79702L11.1704 12.2792C11.1181 12.4363 11.1617 12.6065 11.2751 12.7243C11.3581 12.8072 11.4715 12.8508 11.585 12.8508C11.6286 12.8508 11.6766 12.8421 11.7202 12.829L15.2024 11.6988C15.2679 11.677 15.329 11.6421 15.377 11.5941L22.5333 4.43774C23.0351 3.93593 23.0351 3.12429 22.5333 2.62684ZM15.0715 10.6647L13.3348 8.92793L18.5362 3.72647L20.273 5.4632L15.0715 10.6647ZM12.9115 9.73956L14.2555 11.0836L12.2657 11.7294L12.9115 9.73956ZM21.9181 3.81811L20.8926 4.84356L19.1559 3.10684L20.1813 2.08138C20.3384 1.92429 20.6002 1.92429 20.7573 2.08138L21.9181 3.24211C22.0751 3.3992 22.0751 3.65665 21.9181 3.81811Z"
                      fill="#979797"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Assigned Participants</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-80 py-1 px-1">
                  {selectedEmployees?.length > 0 && (
                    <div className="avatar-group avatar-group-sm avatar-group-overlapped me-6 pointer">
                      {selectedEmployees?.slice(0, 4)?.map((emp) => {
                        return (
                          <CustomTooltip text={emp?.name} placement="bottom">
                            <Avatar
                              name={emp?.name}
                              count={1}
                              image={emp?.image}
                              size="sm"
                              color="primary"
                            />
                          </CustomTooltip>
                        );
                      })}
                      {selectedEmployees?.length > 4 && (
                        <div className="avatar avatar-xs avatar-soft-indigo avatar-rounded">
                          <span className="initial-wrap">
                            +{selectedEmployees.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {selectedEmployees?.length === 0 && (
                    <span className="px-2 py-1">No Selected Employees </span>
                  )}
                </div>
                <span className="d-flex align-items-center justify-content-center w-20 py-1 px-2 fs-7">
                  <CustomTooltip text="add assignee" placement="bottom">
                    <span
                      className="btn btn-icon circle btn-sm btn-soft-primary"
                      onClick={() => {
                        setassigneeModal(true);
                      }}
                    >
                      <span className="feather-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-add"
                          viewBox="0 0 16 16"
                        >
                          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                          <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                        </svg>
                      </span>
                    </span>
                  </CustomTooltip>
                </span>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Schedule Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-100 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="date"
                    name="activityDate"
                    required
                    value={activityData.activityDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Activity Group</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className="d-flex align-items-center justify-content-between w-100  py-2 px-2  text-secondary"
                      aria-expanded="false"
                      type="button"
                      disabled
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        handleGetAllGroup();
                      }}
                    >
                      {statusGroup?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : (
                        <>
                          {allGroups?.map((item, index) => (
                            <span
                              disabled={
                                allActivity?.activityGroup?._id === item?._id
                              }
                              className="dropdown-item text-capitalize d-flex align-items-center gap-1 border-bottom rounded-0"
                              key={item._id}
                              value={item._id}
                              onClick={() => {
                                setstatusGroup(item);
                              }}
                            >
                              {index + 1}. {item?.name}
                            </span>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Schedule Time</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 ">
                    <input
                      className="form-control  border-0 rounded-0 rounded-3 py-2"
                      type="time"
                      name="activityTime"
                      required
                      value={activityData?.activityTime}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label">Status</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className={`d-flex align-items-center justify-content-between w-100  py-2 px-2  dropdown-toggle text-capitalize`}
                      aria-expanded="false"
                      type="button"
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        handleGetAllStatus(statusGroup?._id);
                      }}
                    >
                      {statusId?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : allStatus?.length > 0 ? (
                        <>
                          {allStatus?.map((status, index) => {
                            return (
                              <>
                                <button
                                  className="dropdown-item text-capitalize  d-flex align-items-center border-bottom rounded-0"
                                  type="button"
                                  onClick={() => {
                                    handleGetMandatoryTask(
                                      allActivity?._id,
                                      status?._id,
                                      allActivity,
                                      status?.name
                                    );
                                  }}
                                  disabled={status?._id === statusId?._id}
                                >
                                  {index + 1}. {status?.name} (
                                  {status?.activityGroupStatus?.name})
                                </button>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <span> No Status Found</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {allActivity?.isLog === true && (
            <div className="row gx-3 px-3 w-100 mt-1">
              <div className="col-sm-6 mt-3">
                <label className="form-label">Recording Link</label>

                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                    <div className="d-flex align-items-center justify-content-between w-100 ">
                      <input
                        className="form-control  border-0 rounded-0 rounded-3 py-2"
                        type="text"
                        pattern="https?://(?:www\.)?\S+"
                        name="recordingLink"
                        required
                        value={activityData?.recordingLink}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mt-3">
                <label className="form-label">Duration Time </label>

                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                    <div className="d-flex align-items-center justify-content-between w-100 ">
                      <input
                        className="form-control  border-0 rounded-0 rounded-3 py-2"
                        type="number"
                        name="duration"
                        required
                        value={activityData?.duration}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {dateAndTimeFormatter(allActivity?.updatedAt)}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Deadline Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {allActivity?.dealLineDate
                      ? dateAndTimeFormatter(allActivity?.dealLineDate)
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Created By</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.createdBy?.name}
                      count={1}
                      image={allActivity?.createdBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.createdBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified by</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.actionBy?.name}
                      count={1}
                      image={allActivity?.actionBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.actionBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-2">
            <div className="col-sm-6">
              <div className="form-group">
                <div className="form-group">
                  <label className="form-label">Note</label>
                  <div className="todo-toolbar">
                    <textarea
                      className="form-control"
                      rows="3"
                      name="notes"
                      value={activityData.notes}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {allActivity?.taskType === "meeting" && (
        <>
          <div className="row gx-3 px-3 w-100 mt-4">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Title</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-90 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="text"
                    name="taskTitle"
                    required
                    value={activityData.taskTitle}
                    onChange={handleChange}
                    placeholder="Task Title"
                  />
                </div>
                <span className="d-flex align-items-center justify-content-center w-10 py-1 px-2 fs-7">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.413 10.5907C18.173 10.5907 17.9767 10.787 17.9767 11.027V21.0459C17.9767 21.5914 17.5316 22.0321 16.9861 22.0321H2.95266C2.4072 22.0321 1.96648 21.587 1.96648 21.0459V7.01247C1.96648 6.46702 2.41157 6.02629 2.95266 6.02629H12.9672C13.2072 6.02629 13.4036 5.82993 13.4036 5.58993C13.4036 5.34993 13.2072 5.15356 12.9672 5.15356H2.95266C1.9272 5.15356 1.09375 5.98702 1.09375 7.01247V21.0503C1.09375 22.0757 1.9272 22.9092 2.95266 22.9092H16.9905C18.0159 22.9092 18.8538 22.0757 18.8538 21.0503V11.027C18.8494 10.787 18.653 10.5907 18.413 10.5907Z"
                      fill="#979797"
                    />
                    <path
                      d="M22.5333 2.62684L21.3726 1.46611C20.8751 0.968654 20.0635 0.968654 19.5617 1.46611L12.4053 8.62247C12.3573 8.67047 12.3181 8.73156 12.3006 8.79702L11.1704 12.2792C11.1181 12.4363 11.1617 12.6065 11.2751 12.7243C11.3581 12.8072 11.4715 12.8508 11.585 12.8508C11.6286 12.8508 11.6766 12.8421 11.7202 12.829L15.2024 11.6988C15.2679 11.677 15.329 11.6421 15.377 11.5941L22.5333 4.43774C23.0351 3.93593 23.0351 3.12429 22.5333 2.62684ZM15.0715 10.6647L13.3348 8.92793L18.5362 3.72647L20.273 5.4632L15.0715 10.6647ZM12.9115 9.73956L14.2555 11.0836L12.2657 11.7294L12.9115 9.73956ZM21.9181 3.81811L20.8926 4.84356L19.1559 3.10684L20.1813 2.08138C20.3384 1.92429 20.6002 1.92429 20.7573 2.08138L21.9181 3.24211C22.0751 3.3992 22.0751 3.65665 21.9181 3.81811Z"
                      fill="#979797"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Assigned Participants</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-80 py-1 px-1">
                  {selectedEmployees?.length > 0 && (
                    <div className="avatar-group avatar-group-sm avatar-group-overlapped me-6 pointer">
                      {selectedEmployees?.slice(0, 4)?.map((emp) => {
                        return (
                          <CustomTooltip text={emp?.name} placement="bottom">
                            <Avatar
                              name={emp?.name}
                              count={1}
                              image={emp?.image}
                              size="sm"
                              color="primary"
                            />
                          </CustomTooltip>
                        );
                      })}
                      {selectedEmployees?.length > 4 && (
                        <div className="avatar avatar-xs avatar-soft-indigo avatar-rounded">
                          <span className="initial-wrap">
                            +{selectedEmployees.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {selectedEmployees?.length === 0 && (
                    <span className="px-2 py-1">No Selected Employees </span>
                  )}
                </div>
                <span className="d-flex align-items-center justify-content-center w-20 py-1 px-2 fs-7">
                  <CustomTooltip text="add assignee" placement="bottom">
                    <span
                      className="btn btn-icon circle btn-sm btn-soft-primary"
                      onClick={() => {
                        setassigneeModal(true);
                      }}
                    >
                      <span className="feather-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-add"
                          viewBox="0 0 16 16"
                        >
                          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                          <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                        </svg>
                      </span>
                    </span>
                  </CustomTooltip>
                </span>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Due Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center justify-content-between w-100 ">
                  <input
                    className="form-control  border-0 rounded-0 rounded-3 py-2"
                    type="date"
                    name="activityDate"
                    required
                    value={reversesDateFormatter(activityData.activityDate)}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-6 mt-3">
              <label className="form-label">Activity Group</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className="d-flex align-items-center justify-content-between w-100  py-2 px-2 text-secondary"
                      aria-expanded="false"
                      type="button"
                      disabled
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        handleGetAllGroup();
                      }}
                    >
                      {statusGroup?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : (
                        <>
                          {allGroups?.map((item, index) => (
                            <span
                              disabled={
                                allActivity?.activityGroup?._id === item?._id
                              }
                              className="dropdown-item text-capitalize d-flex align-items-center gap-1 border-bottom rounded-0"
                              key={item._id}
                              value={item._id}
                              onClick={() => {
                                setstatusGroup(item);
                              }}
                            >
                              {index + 1}. {item?.name}
                            </span>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Start Time</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 ">
                    <input
                      className="form-control  border-0 rounded-0 rounded-3 py-2"
                      type="time"
                      name="activityTime"
                      required
                      value={activityData.activityTime}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">End Time</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 ">
                    <input
                      className="form-control  border-0 rounded-0 rounded-3 py-2"
                      type="time"
                      name="endTime"
                      required
                      value={activityData.endTime}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {dateAndTimeFormatter(allActivity?.updatedAt)}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Deadline Date</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center justify-content-between w-100 py-2 px-2 text-secondary">
                    {allActivity?.dealLineDate
                      ? dateAndTimeFormatter(allActivity?.dealLineDate)
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Status</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="selectable-dropdown w-100">
                  <div className="dropdown selectable-dropdown w-100 ">
                    <div
                      className={`d-flex align-items-center justify-content-between w-100  py-2 px-2  dropdown-toggle text-capitalize`}
                      aria-expanded="false"
                      type="button"
                      data-bs-toggle="dropdown"
                      onClick={() => {
                        handleGetAllStatus(statusGroup?._id);
                      }}
                    >
                      {statusId?.name}
                    </div>

                    <div
                      role="menu"
                      className="dropdown-menu w-100"
                      style={{
                        maxHeight: "40vh",
                        overflow: "auto",
                      }}
                    >
                      {loader3 ? (
                        <span className="text-center">Loading...</span>
                      ) : allStatus?.length > 0 ? (
                        <>
                          {allStatus?.map((status, index) => {
                            return (
                              <>
                                <button
                                  className="dropdown-item text-capitalize  d-flex align-items-center border-bottom rounded-0"
                                  type="button"
                                  onClick={() => {
                                    handleGetMandatoryTask(
                                      allActivity?._id,
                                      status?._id,
                                      allActivity,
                                      status?.name
                                    );
                                  }}
                                  disabled={status?._id === statusId?._id}
                                >
                                  {index + 1}. {status?.name} (
                                  {status?.activityGroupStatus?.name})
                                </button>
                              </>
                            );
                          })}
                        </>
                      ) : (
                        <span> No Status Found</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label">Created By</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.createdBy?.name}
                      count={1}
                      image={allActivity?.createdBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.createdBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-3 px-3 w-100 mt-1">
            <div className="col-sm-6 mt-3">
              <label className="form-label">Last Modified by</label>

              <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                <div className="d-flex align-items-center border rounded-3 w-100 text-dark">
                  <div className="d-flex align-items-center w-100 py-2 px-2">
                    <Avatar
                      name={allActivity?.actionBy?.name}
                      count={1}
                      image={allActivity?.actionBy?.image}
                      size="xxs"
                      color="primary"
                    />
                    <span className="ms-1  text-secondary">
                      {allActivity?.actionBy?.name}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-3">
              <div className="form-group">
                <div className="form-group">
                  <label className="form-label">Note</label>
                  <div className="todo-toolbar">
                    <textarea
                      className="form-control"
                      rows="3"
                      name="notes"
                      value={activityData.notes}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ActivityOverview;
